// Returns true if the current user agent contains the mobile phone vendor name. Considering
// only Android and iPhone devices.
export function isMobilePhone(): boolean {
  return /Android|iPhone/i.test(navigator.userAgent);
}

export function isMacOs(): boolean {
  return window.navigator.userAgent.includes("Mac");
}
